import { jsx as _jsx } from "react/jsx-runtime";
import { Selector, Util } from 'ui-lib';
import * as React from 'react';
export function VerificationOpenIDConfigSelector(props) {
    var choices = Util.idNamePairsFromArray(props.authNames);
    return _jsx(Selector, { name: props.name, items: choices, label: "Verification OpenID Config" });
}
